import { WorkOrderStatusEnum } from 'gql/graphql';
import { Button, IconArrowLeft, IconArrowRight } from 'uikit';

import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';
import { useCallback, useState } from 'react';

interface ISmrTotalHeaderComponent extends IHeaderParams {
    workOrderStatus?: WorkOrderStatusEnum;
    collapseKeys: string[];
}

export const SmrTotalHeaderComponent: React.FC<ISmrTotalHeaderComponent> = (props) => {
    const { workOrderStatus, collapseKeys, displayName, api } = props;
    const [isExpanded, setIsExpanded] = useState(false);

    const onExpandCollapseClick = useCallback(() => {
        api.setColumnsVisible(collapseKeys, !isExpanded);
        setIsExpanded(!isExpanded);
    }, [api, collapseKeys, isExpanded]);

    return workOrderStatus === WorkOrderStatusEnum.InProgress ? (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {displayName}
            <Button
                view="clear"
                iconRight={isExpanded ? IconArrowLeft : IconArrowRight}
                onlyIcon
                onClick={onExpandCollapseClick}
                size="xs"
                form="brick"
            />
        </div>
    ) : (
        <span>{displayName}</span>
    );
};

SmrTotalHeaderComponent.displayName = 'SmrTotalHeaderComponent';
